<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">Prodotti</h1>
    <div class="mb-6 flex justify-between items-center">

      <!-- PRIMO CAMPO: Ricerca base -->
      <search-filter v-model="form.search" class="w-full max-w-md mr-4" @reset="reset" @submitSearch="submitSearch">
        <label class="block text-gray-700">Eliminati:</label>
        <select v-model="form.trashed" class="mt-1 w-full form-select">
          <option :value="null" />
          <option value="with">Con Eliminati</option>
          <option value="only">Solo Eliminati</option>
        </select>
      </search-filter>

      <!-- SECONDO CAMPO: Ricerca avanzata -->
      <simple-search-filter
        v-if="[5,6,7,8,9,10,11,12,13,14,15,26,32,33].includes(user.id)"
        v-model="form.advanced_search"
        class="w-full max-w-md"
        placeholder="Cerca per nome, categoria, stagione…"
        @reset="reset"
        @submitSearch="submitSearch"
      />

      <!-- Pulsanti di azione -->
      <inertia-link v-if="user.id === 27 || user.id === 30" class="btn-indigo" :href="route('productsImport')">
        <span>📂 Importa Prodotti</span>
      </inertia-link>
      <inertia-link class="btn-indigo" :href="route('products.create')">
        <span>Crea</span>
        <span class="hidden md:inline">Prodotto</span>
      </inertia-link>
    </div>

    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="px-6 pt-6 pb-3">SKU</th>
          <th class="px-6 pt-6 pb-3">Taglia e Colore</th>
          <th class="px-6 pt-6 pb-3">Nome</th>
          <th class="px-6 pt-6 pb-3">Categoria</th>
          <th class="px-6 pt-6 pb-3">Brand</th>
          <th class="px-6 pt-6 pb-3">Prezzo</th>
          <th class="px-6 pt-6 pb-3">Lotto</th>
          <th class="px-6 pt-6 pb-3">Store</th>
        </tr>
        <tr v-for="product in products.data" :key="product.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center focus:text-indigo-500" :href="route('products.edit', product.id)">
              {{ product.sku || product.sku2 }}
              <icon v-if="product.deleted_at" name="trash" class="flex-shrink-0 w-3 h-3 fill-gray-400 ml-2" />
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center focus:text-indigo-500" :href="route('products.edit', product.id)">
              {{ product.taglia }} - {{ product.colore }}
              <icon v-if="product.deleted_at" name="trash" class="flex-shrink-0 w-3 h-3 fill-gray-400 ml-2" />
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center focus:text-indigo-500" :href="route('products.edit', product.id)">
              {{ product.name.length > 30 ? product.name.slice(0, 30) + '…' : product.name }}
              <icon v-if="product.deleted_at" name="trash" class="flex-shrink-0 w-3 h-3 fill-gray-400 ml-2" />
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center focus:text-indigo-500" :href="route('products.edit', product.id)">
              {{ product.categoria }}
              <icon v-if="product.deleted_at" name="trash" class="flex-shrink-0 w-3 h-3 fill-gray-400 ml-2" />
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center focus:text-indigo-500" :href="route('products.edit', product.id)">
              {{ product.brand }}
              <icon v-if="product.deleted_at" name="trash" class="flex-shrink-0 w-3 h-3 fill-gray-400 ml-2" />
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center focus:text-indigo-500" :href="route('products.edit', product.id)">
              {{ product.prezzo_unitario }} €
              <icon v-if="product.deleted_at" name="trash" class="flex-shrink-0 w-3 h-3 fill-gray-400 ml-2" />
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center focus:text-indigo-500" :href="route('products.edit', product.id)">
              <h1 v-if="product.batch">{{ product.batch.nome }}</h1>
              <icon v-if="product.deleted_at" name="trash" class="flex-shrink-0 w-3 h-3 fill-gray-400 ml-2" />
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center focus:text-indigo-500" :href="route('products.edit', product.id)">
              <h1 v-if="product.store">{{ product.store.name }}</h1>
              <icon v-if="product.deleted_at" name="trash" class="flex-shrink-0 w-3 h-3 fill-gray-400 ml-2" />
            </inertia-link>
          </td>
        </tr>
        <tr v-if="products.data.length === 0">
          <td class="border-t px-6 py-4" colspan="4">Nessun prodotto trovato</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="products.links" />
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'
import SimpleSearchFilter from '@/Shared/SimpleSearchFilter'

export default {
  computed: {
    user() {
      return this.$page.props.auth.user;
    },
  },
  metaInfo: { title: 'Prodotti' },
  components: {
    Icon,
    Pagination,
    SearchFilter,
    SimpleSearchFilter,
  },
  layout: Layout,
  props: {
    filters: Object,
    products: Object,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        advanced_search: this.filters.advanced_search,
        trashed: this.filters.trashed,
      },
    }
  },
  methods: {
    submitSearch() {
      this.$inertia.get(this.route('products'), pickBy(this.form), {
        preserveState: true,
        replace: true,
        onSuccess: (page) => {
          this.products = page.props.products;
        },
      });
    },
    reset() {
      this.form = mapValues(this.form, () => null);
    },
  },
}
</script>